//@formatter:off
/**
 * @ngdoc filter
 * @name encodeUri
 * @module portaro.filters
 * @kind function
 *
 *
 * @requires ng.$window
 *
 * @description
 * Filter is using (window.encodeURIComponent)[https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent] function to encode input.
 *
 * @example
 * <example module="encodeUriFilterExample" name="encodeUriFilterExample" frame-no-resize="true">
    <file name="index.html">
        <main ng-init="input = ''">
            <div>
                <label for="input">Input value: </label>
                <input id="input" type="text" ng-model="input">
            </div>
            <div>
                Encoded output: {{input | encodeUri}}
            </div>
        </main>
    </file>
    <file name="script.js">
        angular.module('encodeUriFilterExample', ['portaro.filters']);
    </file>
 * </example>
 *
 */
//@formatter:on
/*@ngInject*/
export default function encodeUriFilter($window) {
        return $window.encodeURIComponent;
};

encodeUriFilter.filterName = 'encodeUri';